import { createShortlistStore } from './storage'
import {
  bindShortlistToggle,
  candidateFromElement,
  shortlistFailureMessage,
} from './toggle'

const initializedRoots = new WeakSet()

function candidateFromShortlistRoot(root, origin = window.location.origin) {
  const firstSlide = root.ownerDocument.querySelector('#reform-case-main-photos [data-reform-case-photo-section]')
  return candidateFromElement(root, '[data-reform-case-shortlist-candidate]', firstSlide, origin)
}

function setStatus(root, message, isError = false) {
  const status = root.querySelector('[data-reform-case-shortlist-status]')
  if (!(status instanceof HTMLElement)) return

  status.textContent = message
  status.hidden = message === ''
  status.classList.toggle('text-red-700', isError)
  status.classList.toggle('text-gray-700', !isError)
}

function render(root, state, message = '', isError = false) {
  const button = root.querySelector('[data-reform-case-shortlist-toggle]')
  const label = root.querySelector('[data-reform-case-shortlist-label]')
  if (!(button instanceof HTMLButtonElement) || !(label instanceof HTMLElement)) return
  if (!state.ok) {
    label.textContent = state.reason === 'invalid-candidate'
      ? 'この事例にはいいねできません'
      : 'いいね機能を利用できません'
    setStatus(root, shortlistFailureMessage(state.reason), true)
    return
  }

  label.textContent = state.label

  setStatus(root, message, isError)
}

export function initReformCaseShortlistDetail({ store = createShortlistStore() } = {}) {
  document.querySelectorAll('[data-reform-case-shortlist-detail]').forEach((root) => {
    if (!(root instanceof HTMLElement) || initializedRoots.has(root)) return
    initializedRoots.add(root)

    const candidate = candidateFromShortlistRoot(root)
    bindShortlistToggle({
      root,
      store,
      candidate,
      buttonSelector: '[data-reform-case-shortlist-toggle]',
      render,
      successMessage: () => 'いいねしました。',
    })
  })
}
